import { Mix } from '@kisters/wiski-web/common';
import { customElement } from 'lit/decorators.js';
import { html } from 'lit';
import { SM, ViewPort } from '@kisters/wiski-web/decorators';
import '@kisters/wiski-web/components/ki-ww-start/ki-ww-start';
import {
  navigateTo,
  getSearchParamString,
  getCurrentPath,
  getNavItems,
  KiAppWWP,
} from '@kisters/wiski-web/components';
import '../../../common/components/ki-menu-hdoe';
import style from './ww-app.css.js';

@customElement('ww-app')
export default class WWApp extends Mix(KiAppWWP) {
  static styles = [KiAppWWP.styles, style];

  // eslint-disable-next-line class-methods-use-this
  _renderFooter() {
    return html`<div class="footer">
      <div class="item">
        <a href="#/html/Barrierefreiheit?">Barrierefreiheit</a>
        <a href="#/html/Impressum?">Impressum</a>
      </div>
      <div class="item desktop">
        &copy; Hydrographischer Dienst Oberösterreich
      </div>
      <div class="item mobile">&copy; HDOÖ</div>
    </div>`;
  }

  // eslint-disable-next-line class-methods-use-this
  _renderMain() {
    return html`<div class="main">
      <ki-app-breadcrumbs maxitems="3"></ki-app-breadcrumbs>
      <div class="main-slot">
        <slot></slot>
      </div>
    </div>`;
  }

  // eslint-disable-next-line class-methods-use-this
  _renderMenu() {
    const menuMode = ViewPort.size === SM ? 'vertical' : 'horizontal';
    // language=html
    return html`
      <ki-menu-hdoe
        slot="nav"
        .direction="${menuMode}"
        @selected="${e => {
          const currentQuery = getSearchParamString() ?? '';
          const currentViewType = getCurrentPath().replace(/[^/]+$/, '');
          const newViewType = e.detail.value.replace(/[^/]+$/, '');
          let newUrl = e.detail.value;
          if (currentViewType === newViewType) {
            newUrl = `${newUrl}${
              currentQuery.charAt(0) === '?' ? '' : '?'
            }${currentQuery}`;
          }
          navigateTo(newUrl);
        }}"
        .items="${getNavItems()}"
      ></ki-menu-hdoe>
    `;
  }

  _renderHeader() {
    return html`
      <div class="header" style="cursor: pointer">
        <ki-icon-btn
          icon="ki ki-bars"
          class="toggle-btn"
          @click="${this.toggleSideBar}"
        ></ki-icon-btn>
        <div class="logo-left">
          <img
            alt="Wappen Land Oberoesterreich"
            src="./images/ooe_wappen.svg"
            onclick="window.open('https://www.land-oberoesterreich.gv.at/', 'blank')"
          />
          <div
            class="wappenText"
            onclick="window.open('https://www.land-oberoesterreich.gv.at/', 'blank')"
          >
            LAND<br />
            OBERÖSTERREICH
          </div>
        </div>
        <div class="nav">${ViewPort.size === SM ? '' : this._renderMenu()}</div>
        <div class="logo-right">
          <img
            alt="Logo Oberoesterreich"
            src="./images/ooe_logo.svg"
            onclick="window.open('https://www.upperaustria.at/', 'blank')"
          />
        </div>
      </div>
    `;
  }
}
